/**
 * IndexedDB-backed offline queue.
 * Replaces the earlier localStorage prototype so we can hold thousands
 * of queued mutations (including receipt/photo data URLs) without hitting
 * the 5 MB localStorage cap.
 */

const DB_NAME = "kings-pms";
const DB_VERSION = 1;
const STORE = "outbox";

let dbPromise;
const openDb = () => {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    if (!("indexedDB" in window)) return reject(new Error("IndexedDB unavailable"));
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
};

const withStore = async (mode, fn) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const store = tx.objectStore(STORE);
    const result = fn(store);
    tx.oncomplete = () => resolve(result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
};

export const outboxAdd = async (item) => {
  await withStore("readwrite", (s) => s.add({ ...item, queued_at: new Date().toISOString() }));
};

export const outboxAll = async () => {
  return withStore("readonly", (s) => new Promise((resolve) => {
    const req = s.getAll();
    req.onsuccess = () => resolve(req.result || []);
  }));
};

export const outboxRemove = async (id) => {
  await withStore("readwrite", (s) => s.delete(id));
};

export const outboxCount = async () => {
  return withStore("readonly", (s) => new Promise((resolve) => {
    const req = s.count();
    req.onsuccess = () => resolve(req.result || 0);
  }));
};
